// src/utils/registerGlobalComponents.js
import Vue from 'vue'

// 自动读取 components 目录下的 .vue 文件（不递归子目录，可根据需求调整）
const componentsContext = require.context('@/components', false, /\.vue$/)

// 遍历所有组件文件，批量注册
componentsContext.keys().forEach(filePath => {
	// 获取组件配置
	const componentConfig = componentsContext(filePath)
	// 提取组件名：比如 './Header.vue' → 'Header'
	const componentName = filePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	// 全局注册组件
	Vue.component(
		componentName,
		// 优先取组件的 default 导出（兼容普通组件写法）
		componentConfig.default || componentConfig
	)
})